var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"token_balance"},[_c('Number',{attrs:{"decimals":"18","number":_vm.balance}}),_vm._v(" "+_vm._s(_vm.symbol)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }